import {OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {LayoutService} from './service/app.layout.service';
import {UserService} from '../services/user.service';
import {NGXLogger} from 'ngx-logger';
import {AuthService} from "@auth0/auth0-angular";
import {UtentiService} from "../services/latitude/utenti/utenti.service";

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {

    model: any[] = [];

    ownViewerEnvironment: string;

    uiReady:                boolean;
    dataReady:              boolean;

    constructor(
        public layoutService: LayoutService,
        private userService: UserService,
        private logger: NGXLogger,
        private utentiService: UtentiService,
        private auth: AuthService
    ) {

        this.ownViewerEnvironment = null;

        this.utentiService.getUtenti().subscribe((data) => {
        });

        this.auth.user$.subscribe((user) => {
            if (user != null) {
                this.utentiService.getByIdAuth0(user.sub.split("|")[1]).subscribe((data) => {
                    this.ownViewerEnvironment = data.ambienteVisualizzatore;
                    this.dataReady = true;
                    this.onReady();

                });

            } else {
                this.dataReady = true;
                this.onReady();

            }


        });
    }

    onReady () {
        if (this.dataReady && this.uiReady) {
            this.initMenu();
        }
    }

    ngOnInit() {
        this.uiReady = true;
        this.onReady();
        
        // Reinizializza il menu dopo un breve delay per assicurarsi che i ruoli siano stati impostati
        setTimeout(() => {
            if (this.dataReady && this.uiReady) {
                this.logger.info("Reinizializzazione menu dopo delay - isAdmin: " + this.userService.isAdmin + " isSuperAdmin: " + this.userService.isSuperAdmin);
                console.log("[MENU] Reinizializzazione menu dopo delay - isAdmin:", this.userService.isAdmin, "isSuperAdmin:", this.userService.isSuperAdmin);
                this.initMenu();
            }
        }, 1000);
    }

    initMenu () {
        this.logger.info("initMenu - isAdmin: " + this.userService.isAdmin + " isSuperAdmin: " + this.userService.isSuperAdmin);
        console.log("[MENU] initMenu - isAdmin:", this.userService.isAdmin, "isSuperAdmin:", this.userService.isSuperAdmin);

        let visProjectsSection = [];
        if (this.userService.isAdmin || this.userService.isSuperAdmin) {
            visProjectsSection = [{
                label: 'Visualizzatore',
                icon: 'pi pi-fw pi-map',
                items: [

                    {
                        label: 'Qgis Server',
                        icon: 'pi pi-fw pi-server',
                        routerLink: ['/visualizzatore/servers']
                    },
                    {
                        label: 'Ambienti',
                        icon: 'pi pi-fw pi-globe',
                        routerLink: ['/visualizzatore']
                    },
                ]}];
        } else if (this.ownViewerEnvironment != null) {
            visProjectsSection = [{
                label: 'Visualizzatore', icon: 'pi pi-fw pi-map',
                items: [
                {
                    label: 'Progetti',
                    icon: 'pi pi-fw pi-list',
                    routerLink: ['/visualizzatore/projects']
                    // items:this.euItems
                }
            ]}];
        }

        this.model = [
            {
                label: 'HOME',
                items: [
                    {label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/']},
                    {label: 'Libreria Servizi', icon: 'pi pi-fw pi-book', routerLink: ['/underconstruction']}
                ]
            },
            ...(this.userService.isAdmin || this.userService.isSuperAdmin ? [{
                label: 'ADMIN',
                items: [
                    {label: 'Utenti', icon: 'pi pi-fw pi-users', routerLink: ['/utenti']},
                    {label: 'Servizi', icon: 'pi pi-fw pi-credit-card', routerLink: ['/servizi']},
                    {label: 'Crediti', icon: 'pi pi-fw pi-money-bill', routerLink: ['/gestione-crediti']},
                    {label: 'Stato API', icon: 'pi pi-fw pi-microchip', routerLink: ['/api']},
                    {
                        label: "CDU",
                        icon: 'pi pi-fw pi-list',
                        routerLink: ['/cdu/cdu/admin']
                    }
                ]
            }] : []),
            {
                label: 'SERVIZI',
                items: [
                    {label: 'Geocoder', icon: 'pi pi-fw pi-map-marker', routerLink: ['/geocoder']},
                    {
                        label: 'CDU',
                        icon: 'pi pi-fw pi-building',
                        items: [
                           /*  {
                                label: 'Configurazione',
                                icon: 'pi pi-fw pi-cog',
                                routerLink: ['/cdu/config']
                            },
                            {
                                label: 'Estratti Urbanistici',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/cdu/eu']
                                //items:this.euItems
                            }, */
                            {
                                label: "Certificati",
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/cdu/cdu/reports']
                            }
                        ]
                    },

                    {
                        label: 'Catasto',
                        icon: 'pi pi-fw pi-calculator',
                        items: [
                            {
                                label: 'Prospetti',
                                icon: 'pi pi-fw pi-address-book',
                                routerLink: ['/catasto/prospetti']
                                //items:this.euItems
                            },
                            {
                                label: 'Espropri',
                                icon: 'pi pi-fw pi-minus-circle',
                                routerLink: ['/catasto/espropri']
                                //items:this.euItems
                            },
                            {
                                label: 'Estrazioni',
                                icon: 'pi pi-fw pi-cloud-download',
                                routerLink: ['/catasto-retriever']
                                //items:this.euItems
                            }
                        ]
                    },
                    ...visProjectsSection
                ]
            },
            {
                label: 'CREDITI',
                items: [
                    {label: 'Ordini', icon: 'pi pi-fw pi-cart-plus', routerLink: ['/crediti/ordini'], badge: 'NEW'},
                    {label: 'Transazioni', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/crediti/transazioni']},
                ]
            },
            {
                label: 'HELP',
                items: [
                    {label: 'FAQ', icon: 'pi pi-fw pi-question', routerLink: ['/utilities/icons']},
                    {label: 'Contattaci', icon: 'pi pi-fw pi-envelope', url: ['https://www.primefaces.org/primeflex/'], target: '_blank'},
                ]
            },

        ];
    }


}
